import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72129c3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "back-music-player" }
const _hoisted_2 = { class: "controller" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "status" }
const _hoisted_5 = {
  key: 0,
  class: "time"
}
const _hoisted_6 = {
  key: 1,
  class: "time"
}
const _hoisted_7 = { class: "name line1" }
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = ["onMousedown"]
const _hoisted_11 = {
  key: 7,
  class: "speed-list"
}
const _hoisted_12 = { class: "title" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "title" }

import backMusic, { State } from '@/store/backMusic';
import * as filters from '@/views/filters';
import { computed, inject, onMounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { ViewContext } from '..';
import i18, { State as I18State } from '@/store/i18'
import Poster from './Poster.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const context = inject('context') as ViewContext
const store = useStore()
const data = computed<State>(() => store.state[backMusic.name])

const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].common)

const state = reactive({
    playing: false,
    loopMode: '0',
    speed: 1,
    listVisible: false,
    speedVisible: false,
    audioVersionVisible: false,
    audioVersion: '',
    dragging: false,
    audioUrl: '',
})
const progress = computed(() => {
    if (data.value.duration > 0) {
        return data.value.currentTime / data.value.duration
    } else {
        return 0
    }
})
const audio = ref<HTMLAudioElement>()
const progressWidth = 410;
const playlist = ref<HTMLDivElement>()

watch(() => data.value.current, checkAudio)
onMounted(() => {
    state.audioVersion = window.localStorage.getItem('audioV') || ''
    checkAudio()
})

function checkAudio() {
    if (audio.value && data.value.current && data.value.current.url) {
        let url = data.value.current.url;
        if (data.value.bible && data.value.lang == 'hhb' && state.audioVersion) {
            url = backMusic.getBibleOtherAudio(state.audioVersion, data.value.volume, data.value.chapter)
            backMusic.loadAudoSubtitle(store, state.audioVersion)
        } else {
            backMusic.loadAudoSubtitle(store, data.value.lang)
        }
        state.audioUrl = url
        audio.value.src = url || 'undefined'
        audio.value.playbackRate = state.speed
        audio.value.play();
        context.registerMedia(pause)
    } else {
        state.audioUrl = ''
        pause()
    }
}
function play() {
    if (audio.value && state.audioUrl) {
        audio.value.play()
        context.registerMedia(pause)
    }
}

function pause() {
    if (audio.value) {
        audio.value.pause()
    }
}

function prev() {
    if (data.value.bible) {
        backMusic.playBible(store, data.value.volume, data.value.chapter - 1, data.value.lang)
    } else {
        let target = 0;
        if (data.value.current) {
            //@ts-ignore
            let i = data.value.list.findIndex(item => item.urlid == data.value.current.urlid)
            target = i - 1
            if (target < 0) {
                target = data.value.list.length - 1
            }
        }
        backMusic.play(store, data.value.list[target])
    }
}

function next(loop: boolean) {
    if (data.value.bible) {
        backMusic.playBible(store, data.value.volume, data.value.chapter + 1, data.value.lang)
    } else {
        let target = 0;
        if (data.value.current) {
            //@ts-ignore
            let i = data.value.list.findIndex(item => item.urlid == data.value.current.urlid)
            target = i + 1
        }
        if (target > data.value.list.length - 1) {
            if (loop || state.loopMode == '0') {
                target = 0;
            } else {
                return;
            }
        }
        backMusic.play(store, data.value.list[target])
    }
}

function reset(item: MovieResource) {
    backMusic.play(store, item);
}

function onPlay() {
    state.playing = true
}

function onPause() {
    state.playing = false
}

function onEnd() {
    state.playing = false
    if (state.loopMode == '0') {
        next(false)
    } else if (state.loopMode == '1') {
        audio.value?.play()
    }
}

function onTimeUpdate() {
    if (audio.value) {
        data.value.duration = audio.value.duration;
        if (!state.dragging) {
            data.value.currentTime = audio.value.currentTime;
        }
    }
}

function onSkip({ offsetX }: MouseEvent) {
    if (audio.value) {
        let value = offsetX / progressWidth
        if (value < 0) {
            value = 0
        } else if (value > 1) {
            value = 1
        }
        audio.value.currentTime = value * data.value.duration
    }
}

function onMouseDown(e: MouseEvent) {
    let fromX = e.clientX;
    state.dragging = true;
    document.onmousemove = (e) => {
        let value = (e.clientX - fromX) / progressWidth
        if (value < 0) {
            value = 0
        } else if (value > 1) {
            value = 1
        }
        data.value.currentTime += data.value.duration * value;
        fromX = e.clientX;
    }

    document.onmouseup = (e) => {
        if (audio.value) {
            audio.value.currentTime = data.value.currentTime;
        }
        document.onmousemove = null;
        document.onmouseup = null;
        setTimeout(() => {
            state.dragging = false;
        }, 1000);
    }
}

function onShowSpeed() {
    state.speedVisible = true
}

function onSpeedChange(value: number) {
    state.speed = value
    state.speedVisible = false
    if (audio.value) {
        audio.value.playbackRate = value
    }
}

function onShowPlayList() {
    state.listVisible = !state.listVisible
    document.onmousedown = () => {
        document.onmousedown = null
        state.listVisible = false
    }
    if (state.listVisible) {
        setTimeout(() => {
            if (playlist.value) {
                let i = data.value.list.findIndex(item => item.urlid == data.value.current?.urlid)
                playlist.value.scrollTop = i * 20;
            }
        }, 100);
    }
}

function onClose() {
    backMusic.shutdown(store)
}

function onShowBibleAudio() {
    state.audioVersionVisible = !state.audioVersionVisible
    document.onmousedown = () => {
        document.onmousedown = null
        state.audioVersionVisible = false
    }
}
function onChangeAudioVersion(version: string) {
    state.audioVersion = version
    checkAudio()
    window.localStorage.setItem('audioV', version)
}

function onLoopChange() {
    switch (state.loopMode) {
        case '0':
            state.loopMode = '1'
            break;
        case '1':
            state.loopMode = ''
            break;
        default:
            state.loopMode = '0'
            break;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("audio", {
      ref_key: "audio",
      ref: audio,
      onPlay: onPlay,
      onPause: onPause,
      onEnded: onEnd,
      onTimeupdate: onTimeUpdate
    }, null, 544),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Poster, {
        url: _unref(data).movie?.thumb
      }, null, 8, ["url"]),
      _createElementVNode("a", {
        class: "prev icon i-shangyishou",
        onClick: prev
      }),
      (_unref(state).playing)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "pause icon i-bofangzanting",
            onClick: pause
          }))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "play icon i-bofang",
            onClick: play
          })),
      _createElementVNode("a", {
        class: "next icon i-xiayishou",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (next(true)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(state).audioUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(filters).leftTime(_unref(data).currentTime)) + " / " + _toDisplayString(_unref(filters).leftTime(_unref(data).duration)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(lang).audio_not_found), 1)),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(data).movie && _unref(data).movie.title ? '《' + _unref(data).movie.title + '》' : null) + " " + _toDisplayString(_unref(data).current?.title), 1)
        ]),
        _createElementVNode("div", {
          class: "track",
          onClick: onSkip
        }, [
          _createElementVNode("div", {
            class: "progress",
            style: _normalizeStyle({ width: _unref(progress) * 100 + '%' })
          }, [
            _createElementVNode("a", {
              class: "thumb",
              onMousedown: _withModifiers(onMouseDown, ["stop"])
            }, null, 40, _hoisted_8)
          ], 4)
        ])
      ]),
      (_unref(state).loopMode == '0')
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "mode icon i-loop-once on",
            onClick: onLoopChange
          }))
        : (_unref(state).loopMode == '1')
          ? (_openBlock(), _createElementBlock("a", {
              key: 3,
              class: "mode icon i-loop_one on",
              onClick: onLoopChange
            }))
          : (_openBlock(), _createElementBlock("a", {
              key: 4,
              class: "mode icon i-loop_one",
              onClick: onLoopChange
            })),
      _createElementVNode("a", {
        class: "mode icon",
        onClick: onShowSpeed
      }, _toDisplayString(_unref(state).speed) + "x", 1),
      (!_unref(data).bible)
        ? (_openBlock(), _createElementBlock("a", {
            key: 5,
            class: _normalizeClass(["list icon i-yinpinliebiao", { on: _unref(state).listVisible }]),
            onMousedown: _withModifiers(onShowPlayList, ["stop"])
          }, null, 42, _hoisted_9))
        : _createCommentVNode("", true),
      (_unref(data).bible && _unref(data).lang == 'hhb')
        ? (_openBlock(), _createElementBlock("a", {
            key: 6,
            class: _normalizeClass(["list icon i-yinpinliebiao", { on: _unref(state).listVisible }]),
            onMousedown: _withModifiers(onShowBibleAudio, ["stop"])
          }, null, 42, _hoisted_10))
        : _createCommentVNode("", true),
      (_unref(state).speedVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).speed == 3 }),
              onMousedown: _cache[1] || (_cache[1] = ($event: any) => (onSpeedChange(3)))
            }, "3X", 34),
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).speed == 2 }),
              onMousedown: _cache[2] || (_cache[2] = ($event: any) => (onSpeedChange(2)))
            }, "2X", 34),
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).speed == 1.5 }),
              onMousedown: _cache[3] || (_cache[3] = ($event: any) => (onSpeedChange(1.5)))
            }, "1.5X", 34),
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).speed == 1 }),
              onMousedown: _cache[4] || (_cache[4] = ($event: any) => (onSpeedChange(1)))
            }, "1X", 34),
            _createElementVNode("a", {
              class: _normalizeClass({ on: _unref(state).speed == 0.5 }),
              onMousedown: _cache[5] || (_cache[5] = ($event: any) => (onSpeedChange(0.5)))
            }, "0.5X", 34)
          ]))
        : _createCommentVNode("", true),
      (_unref(state).listVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 8,
            class: "play-list",
            onMousedown: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(lang).audio_playlist) + " ", 1),
              _createElementVNode("a", {
                class: "icon i-guanbi",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).listVisible = false))
              })
            ]),
            _createElementVNode("div", {
              class: "content",
              ref_key: "playlist",
              ref: playlist
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item, i) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["line1", { on: item.urlid == _unref(data).current?.urlid }]),
                  onClick: ($event: any) => (reset(item))
                }, _toDisplayString(i + 1) + " " + _toDisplayString(item.title), 11, _hoisted_13))
              }), 256))
            ], 512)
          ], 32))
        : _createCommentVNode("", true),
      (_unref(state).audioVersionVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 9,
            class: "play-list",
            onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(_unref(lang).audio_versions) + " ", 1),
              _createElementVNode("a", {
                class: "icon i-guanbi",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(state).audioVersionVisible = false))
              })
            ]),
            _createElementVNode("div", {
              class: "content",
              ref_key: "playlist",
              ref: playlist
            }, [
              _createElementVNode("a", {
                class: _normalizeClass({ on: _unref(state).audioVersion == '' }),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (onChangeAudioVersion('')))
              }, " 磐石圣经纯声版 ", 2),
              _createElementVNode("a", {
                class: _normalizeClass({ on: _unref(state).audioVersion == '戏剧版' }),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (onChangeAudioVersion('戏剧版')))
              }, " 华语有声戏剧版 ", 2),
              _createElementVNode("a", {
                class: _normalizeClass({ on: _unref(state).audioVersion == '儿童版' }),
                onClick: _cache[11] || (_cache[11] = ($event: any) => (onChangeAudioVersion('儿童版')))
              }, " 儿童版 ", 2)
            ], 512)
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("a", {
      class: "icon i-guanbi close",
      onClick: onClose
    })
  ]))
}
}

})